// extracted by mini-css-extract-plugin
export default {"descriptionFiltersContainer":"descriptionFilters_descriptionFiltersContainer__3H6Pf","collapsableComponent":"descriptionFilters_collapsableComponent__pnhvc"};